<template>
  <section class="app-parsing border container">
    <h3 class="block__topic" id="parsing">大赛全解析</h3>

    <div class="fill"></div>

    <div class="app-parsing-main">
      <div class="app-parsing-main-container">
        <div class="app-parsing-main-container__video" v-show="playing">
          <video
            ref="video"
            controls
            :src="current.video_url"
            :poster="current.mobile_thumbs ? current.mobile_thumbs[0] : ''"
            webkit-playsinline="true"
            playsinline="true"
            x5-video-player-type="h5-page"
            x5-video-player-fullscreen="true"
            t7-video-player-type="inline"
            x-webkit-airplay="true"
          />
        </div>

        <div
          v-if="!playing"
          class="app-parsing-main-container__poster"
          :style="{
            background: `#000 url(${
              current.mobile_thumbs ? current.mobile_thumbs[0] : ''
            }) center/contain no-repeat`,
          }"
        ></div>

        <transition name="fade">
          <div v-if="!playing" class="app-parsing-main-container__text">
            <span class="title">{{ current.title }}</span>
            <span>{{ duration }}</span>
          </div>
        </transition>

        <div
          v-if="!playing"
          class="app-parsing-main-container__icon"
          @click="onPlay"
        ></div>
      </div>
    </div>

    <div class="app-parsing-list">
      <span class="app-parsing-list__prev"></span>

      <vue-slick-carousel v-bind="slickSettings" v-if="list.length > 0">
        <div
          v-for="item in list"
          class="app-parsing-list-item"
          :key="item.id"
          :class="{ active: current.id === item.id }"
          @click="() => onChangeCurrent(item)"
        >
          <div class="app-parsing-list-item-thumb">
            <img
              :src="item.web_thumbs[0]"
              class="app-parsing-list-item__cover"
            />
            <div class="app-parsing-list-item__icon">
              <img
                src="../../assets/play-icon@1x.png"
                srcset="../../assets/play-icon@2x.png 2x"
              />
            </div>
            <img
              src="../../assets/play-mask@2x.png"
              class="app-parsing-list-item__mask"
            />
            <img
              src="../../assets/play-mask-active@2x.png"
              class="app-parsing-list-item__mask--active"
            />
          </div>
          <div
            class="app-parsing-list-item__title"
            :style="{ color: current.id === item.id ? '#EBC4BC' : '' }"
          >
            <v-clamp autoresize :max-lines="2">{{ item.title }}</v-clamp>
          </div>
        </div>
      </vue-slick-carousel>

      <span class="app-parsing-list__next"></span>
    </div>
  </section>
</template>

<script>
import device from "@jin10/utils/lib/device"
import VClamp from 'vue-clamp'
import VueSlickCarousel from "vue-slick-carousel"
import "vue-slick-carousel/dist/vue-slick-carousel.css"
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css"
import { getReference, getReferenceById } from "@/api"

export default {
  name: "Parsing",
  components: {
    VClamp,
    VueSlickCarousel
  },
  data() {
    return {
      slickSettings: {
        infinite: true,
        speed: 500,
        centerMode: true,
        focusOnSelect: true,
        slidesToShow: device.isMobile ? 2 : 3,
        slidesToScroll: 1,
        touchThreshold: 5,
        lazyLoad: "ondemand",
        centerPadding: '12%'
      },
      playing: false,
      duration: "",
      current: {},
      list: [],
    }
  },
  mounted() {
    getReference({ category_id: 345, types: "video", page_size: 50 })
      .then((res) => {
        const { list = [] } = res.data

        this.list = list

        this.list.length && this.onChangeCurrent(this.list[0])
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    onPlay() {
      this.playing = true

      this.$refs.video.play()
    },
    onChangeCurrent(current) {
      this.playing = false

      getReferenceById({
        type: current.type,
        id: current.id
      })
        .then((res) => {
          this.current = res.data

          const video = this.$refs.video

          video.onloadedmetadata = () => {
            this.duration = this.returnMS(video.duration)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    returnMS(second) {
      const m = Math.floor((Math.ceil(second) % (60 * 60)) / 60)
      const s = Math.ceil(second) % 60
      return (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.app-parsing {
  position: relative;
  margin: percentage(80px / $baseWidth) auto 0;
  border: 1px solid transparent;
  box-sizing: border-box;

  .fill {
    margin: percentage(72px / 1200px) auto 0;
    padding-top: percentage(618px / 1200px);
  }

  &-main {
    position: absolute;
    top: 0;
    left: 50%;
    margin: percentage(72px / 1200px) auto 0;
    transform: translate(-50%, 0);
    width: percentage(1476px / 1200px);
    padding-top: percentage(618px / 1200px);
    @include image-2x(
      "../../assets/video-bg@1x.png",
      center top,
      no-repeat,
      100% auto
    );

    &-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: percentage(960px / 1476px);
      padding-top: percentage(540px / 1476px);
      background: #0e0917;

      &__text {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 14px 21px;
        line-height: 18px;
        color: #ebc4bc;
        font-size: 18px;
        background: rgba(0, 0, 0, 0.8);
        box-sizing: border-box;
        span {
          float: right;
          font-size: 14px;
        }

        .title {
          float: left;
          width: 80%;
          color: #ebc4bc;
          @include line(1);
        }
      }

      &__video,
      &__poster {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        video {
          width: 100%;
          height: 100%;
        }
      }

      &__icon {
        @include middle();
        width: percentage(104px / 960px);
        padding-top: percentage(90px / 960px);
        @include image-2x(
          "../../assets/play-icon@1x.png",
          center,
          no-repeat,
          100% auto
        );
        cursor: pointer;

        &:hover {
          transition: transform 0.3s;
          transform: translate(-50%, -50%) scale(1.05);
        }
      }
    }

    &__img {
      position: absolute;
      width: 100%;
      height: auto;
    }
  }

  &-list {
    position: relative;
    width: percentage(948px / 1200px);
    margin: percentage(25px / 1200px) auto 0;

    &::after, &::before {
      content: "";
      display: block;
      width: percentage(64px / 948px);
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 99;
      // background: linear-gradient(
      //     to left,
      //     rgba(255, 255, 255, 0),
      //     rgb(15, 9, 24)
      //   );
      pointer-events: none;
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAACLCAYAAAD4QWAuAAAB7klEQVR4Xu2cu07DQBBFZ9a2AjQoDeJX+BB+n4redIhrZwftI8hFkIjiBulU1ia2fD1ejY/Xd8Yf759XM5O5ycLk7ooImbksYvHUxm7Wfk/19/p/WCiV/XM/zkJWx+24sp9bUnjZunJeNY6Tci7j3LZjUj5luSed1qy7w7Asy0mjT/oaVk3Tg+ZZerUXeRUbJktFjCl1EfUCIpZ6cmsnqyK3YouYMr4ktojzkwYbFXmVD0VsVFHZc70Ir6L7uIv1w7Cks9jPVdOxiTV772K3kf0R2yJ7Fnd7ZHskPcm72Gsia7tHNods6NPAQtlDQ7n4GlFXLneoRLbc9vEvkf3QdHzSPL+p3Ok2DZizzNkdswFzljzbHh6/P8HIs7ABbHAbdZFnybPkWXi2vWhuH7e8g+35dkueJc+SZ8mz5NntKiJrXazPsj4LG8AGsAFsABvABny7LR+a+XZ7/ioOG8AGsAFsABvABrABbLB1zMEGsAFsABvABrABbAAbwAbUKVxTAYJ/Fv8s/ln8s9SD1Uo76sGoB6OGsVeHwgawAWwAG8AGsAG14vQ32HaOgA1gA9gANoANYAPYADaADejXRb+u/Tqh4evC14WvC18Xvi58Xfi68HXh68LXha9r09mX/rMXGjzTr4t+XfT5/l99vr8Bt5Rt6bs7GtUAAAAASUVORK5CYII=") top/cover no-repeat;
    }

    &::after {
      content: "";
      left: auto;
      top: 0;
      right: 0;
      bottom: 0;
      // background: linear-gradient(
      //     to left,
      //     rgb(15, 9, 24),
      //     rgba(255, 255, 255, 0)
      //   );
      transform: rotate(180deg);
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAACLCAYAAAD4QWAuAAAB7klEQVR4Xu2cu07DQBBFZ9a2AjQoDeJX+BB+n4redIhrZwftI8hFkIjiBulU1ia2fD1ejY/Xd8Yf759XM5O5ycLk7ooImbksYvHUxm7Wfk/19/p/WCiV/XM/zkJWx+24sp9bUnjZunJeNY6Tci7j3LZjUj5luSed1qy7w7Asy0mjT/oaVk3Tg+ZZerUXeRUbJktFjCl1EfUCIpZ6cmsnqyK3YouYMr4ktojzkwYbFXmVD0VsVFHZc70Ir6L7uIv1w7Cks9jPVdOxiTV772K3kf0R2yJ7Fnd7ZHskPcm72Gsia7tHNods6NPAQtlDQ7n4GlFXLneoRLbc9vEvkf3QdHzSPL+p3Ok2DZizzNkdswFzljzbHh6/P8HIs7ABbHAbdZFnybPkWXi2vWhuH7e8g+35dkueJc+SZ8mz5NntKiJrXazPsj4LG8AGsAFsABvABny7LR+a+XZ7/ioOG8AGsAFsABvABrABbLB1zMEGsAFsABvABrABbAAbwAbUKVxTAYJ/Fv8s/ln8s9SD1Uo76sGoB6OGsVeHwgawAWwAG8AGsAG14vQ32HaOgA1gA9gANoANYAPYADaADejXRb+u/Tqh4evC14WvC18Xvi58Xfi68HXh68LXha9r09mX/rMXGjzTr4t+XfT5/l99vr8Bt5Rt6bs7GtUAAAAASUVORK5CYII=") top/cover no-repeat;
    }

    &-item {
      position: relative;
      padding: 0 percentage(72px / 948px);
      box-sizing: border-box;
      cursor: pointer;

      &:focus,
      &:active {
        outline: none;
        box-shadow: none;
      }

      &-thumb {
        width: 100%;
        position: relative;
        overflow: hidden;
      }

      &__title {
        margin-top: 20px;
        font-size: 14px;
        color: #9c6159;
        line-height: 18px;
        text-align: center;
        @include line(2);
      }

      &__cover,
      &__icon {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }

      &__icon {
        height: 100%;
        background: rgba(0, 0, 0, 1);
        opacity: 0.6;

        img {
          @include middle();
          width: percentage(42px / 170px);
        }
      }

      &__mask,
      &__mask--active {
        position: relative;
        width: 100%;
      }

      &__mask--active {
        display: none !important;
      }

      &.active {
        .app-parsing-list-item__mask--active {
          display: block !important;
        }

        .app-parsing-list-item__mask,
        .app-parsing-list-item__icon {
          display: none !important;
        }
      }
    }
  }

  .block__topic {
    position: absolute;
    top: 0;
    left: 50%;
    width: percentage(266px / 1200px);
    padding-top: percentage(56px / 1200px);
    transform: translate(-50%, 0);
    @include image-2x(
      "../../assets/title-parsing@1x.png",
      center top,
      no-repeat,
      100% auto
    );
  }
}

@include mobile {
  .app-parsing {
    margin: percentage(46px / 414px) auto 0;

    &-main,
    .fill {
      width: 100%;
      background: none;
      margin: percentage(51px / 406px) auto 0;
      padding: percentage(220px / 390px) 0 0;

      &-container {
        width: 100%;
        padding-top: percentage(220px / 390px);

        &__video {
          padding: 0 percentage(6px / 406px) 0;
        }

        &__text {
          padding: 8px 12px;
          font-size: 14px;
        }
      }
    }

    &-list {
      width: 90%;
      margin: percentage(16px / 406px) auto 0;

      &::after, &::before {
        // width: percentage(32px / 406px);
        background: none;
      }

      &-item {
        &__title {
          padding: 0;
        }
      }

      /deep/.slick-arrow {
        width: 16px;
        height: 16px;
      }

      /deep/.slick-prev {
        left: 0;
        transform: translate(-100%, 0);
      }

      /deep/.slick-next {
        right: 0;
        transform: translate(100%, 0);
      }
    }

    .block__topic {
      width: percentage(177px / 406px);
      padding-top: percentage(37px / 406px);
    }
  }
}
</style>
